<template>
  <div>
    loading...
  </div>
</template>

<script>
import wx from 'weixin-js-sdk';
// import '@/utils/vconsole'
window.wx = wx;
export default {
  data() {
    return {
      keyStr: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
    };
  },
  mounted() {
    this.metaTag()
    const { thirdAuthUrl, supplierOpenid, appId, code, thirdAuthId } = this.$route.query
    const thirdUrl = this.handleThirdAuthUrl(thirdAuthUrl)
    const { origin, pathname } = location
    const currentUrl = origin + pathname + '?s=gms';
    // eslint-disable-next-line no-undef
    const baseUrl = Config.VUE_APP_BASE_API || process.env.VUE_APP_BASE_API;
    if (supplierOpenid) {
      const jsonData = { openId: supplierOpenid, froms: 'app-short-link' }
      if (thirdAuthId && thirdAuthId != 'null') {
        jsonData.thirdAuthId = thirdAuthId
      }
      wx.miniProgram.postMessage({ data: jsonData })
      setTimeout(() => {
        wx.miniProgram.navigateBack()
      }, 500);
    } else if (code) {
      this.$axios({
        url: (baseUrl + "/mkt/unAuthenticate/app/getUserByJsCode").replace(/([^:]\/)\/+/g, '$1'),
        method: "post",
        params: {
          appId,
          code
        },
      }).then(({ data }) => {
        let thirdAuthId = data.data.identity || ''
        if (thirdAuthId == 'null') {
          thirdAuthId = ''
        }
        if (thirdUrl) {
          const encodeUrl = this.encode(currentUrl + `&thirdAuthId=${thirdAuthId}`);//将授权后的指定回调地址base64编码
          const redirectUrl = `${thirdUrl}?redirectUri=${encodeUrl}`;
          window.location.href = redirectUrl;
        } else {
          wx.miniProgram.postMessage({ data: { thirdAuthId, froms: 'app-short-link' } })
          setTimeout(() => {
            wx.miniProgram.navigateBack()
          }, 500);
        }
      })
    } else if (appId) {
      let appendUrl = ''
      if (thirdAuthUrl) {
        appendUrl = `&thirdAuthUrl=${encodeURIComponent(thirdAuthUrl)}`
      }
      this.$axios({
        url: (baseUrl + "/mkt/unAuthenticate/app/buildAuthorizationUrl").replace(/([^:]\/)\/+/g, '$1'),
        method: "get",
        params: {
          appId,
          redirectUri: currentUrl + `&appId=${appId}${appendUrl}`,
          scope: 'snsapi_base',
          state: 'auth_bocjs',
          regCode: 'register'
        },
      }).then(({ data }) => {
        location.replace(data.data)
      }).catch(err => {
        let msg = null;
        if (err.response && err.response.data && err.response.data.message) {
          msg = err.response.data.message
        }
        else {
          msg = "很抱歉，授权异常"
        }
        window.location.replace(process.env.VUE_APP_VIRTUAL_DIR + "error.html?msg=" + msg);
      })
    } else if (thirdUrl) {
      const encodeUrl = this.encode(currentUrl);//将授权后的指定回调地址base64编码
      const redirectUrl = `${thirdUrl}?redirectUri=${encodeUrl}`;
      window.location.href = redirectUrl;
    }
  },
  methods: {
    handleThirdAuthUrl(url) {
      if (url) {
        const wechat_redirect = "#wechat_redirect";
        return decodeURIComponent(url.replace(wechat_redirect, ""))
      }
      return ''
    },
    metaTag() {
      const meta = document.createElement('meta');
      meta.setAttribute('name', 'referrer');
      meta.setAttribute('content', 'no-referrer');
      document.head.appendChild(meta);
    },
    // public method for encoding 
    encode(input) {
      var output = "";
      var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
      var i = 0;
      input = this._utf8_encode(input);
      while (i < input.length) {
        chr1 = input.charCodeAt(i++);
        chr2 = input.charCodeAt(i++);
        chr3 = input.charCodeAt(i++);
        enc1 = chr1 >> 2;
        enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
        enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
        enc4 = chr3 & 63;
        if (isNaN(chr2)) {
          enc3 = enc4 = 64;
        } else if (isNaN(chr3)) {
          enc4 = 64;
        }
        output = output +
          this.keyStr.charAt(enc1) + this.keyStr.charAt(enc2) +
          this.keyStr.charAt(enc3) + this.keyStr.charAt(enc4);
      }
      return output;
    },

    // private method for UTF-8 encoding 
    _utf8_encode(string) {
      string = string.replace(/rn/g, "n");
      var utftext = "";
      for (var n = 0; n < string.length; n++) {
        var c = string.charCodeAt(n);
        if (c < 128) {
          utftext += String.fromCharCode(c);
        } else if ((c > 127) && (c < 2048)) {
          utftext += String.fromCharCode((c >> 6) | 192);
          utftext += String.fromCharCode((c & 63) | 128);
        } else {
          utftext += String.fromCharCode((c >> 12) | 224);
          utftext += String.fromCharCode(((c >> 6) & 63) | 128);
          utftext += String.fromCharCode((c & 63) | 128);
        }
      }
      return utftext;
    }
  }
}

</script>
